var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { app_actions } from '../../../actions/app_actions';
import { BacklogViewWrapper } from '../BacklogApplicationStyles';
import BacklogPagination from '../components/BacklogPagination';
import FundingLogTable, { ALL_FUNDING_LOG_COLUMNS, FUNDING_LOG_FIXED_COLUMN_KEYS } from './FundingLogTable';
import FundingLogFilter from './FundingLogFilter';
import FundingLogCommentsPanel from './FundingLogCommentsPanel';
import FundingLogFinalReviewWarningPopup from './FundingLogFinalReviewWarningPopup';
import FundingLogStatusHistoryPopup from './FundingLogStatusHistoryPopup';
import FundingLogReassignPopup from './FundingLogReassignPopup';
import { exportFundingLog } from './fundingLogExport';
import { useFundingLog, FUNDING_LOG_CONTRACT_STATUS, deriveFundingLogRoleTier, deriveFundingLogCanManage, getFundingLogRowCurrentAssignees, getFundingLogRowHasFinalReviewCM, isFundingLogReviewerRole, FUNDING_LOG_ACCOUNT_NOT_IN_ASPIRE_MESSAGE, } from './useFundingLog';
import ConfirmationAndInformationPoup, { POPUP_TYPE } from '../../../components/UtilityComponents/ConfirmationAndInformationPoup';
import { NavigationConfig as navConfig } from '../../../utils/navigation_config';
var DATE_RANGE_FILTER_LABELS = {
    passedToBookingDate: 'Passed to Booking',
    expectedFundingDate: 'Expected Funding Date',
    fundingDate: 'Funding Date',
    bookedDate: 'Booked Date',
};
var formatFilterChipDate = function (value) {
    var parsed = moment(value, 'YYYY-MM-DD', true);
    return parsed.isValid() ? parsed.format('MM/DD/YYYY') : value;
};
var buildDateRangeChipLabel = function (label, start, end) {
    var startLabel = formatFilterChipDate(start);
    var endLabel = end ? formatFilterChipDate(end) : '';
    return "".concat(label, ": ").concat(startLabel).concat(endLabel && endLabel !== startLabel ? " - ".concat(endLabel) : '');
};
var getFundingActionConfirmation = function (kind, row) {
    if (kind === 'l2') {
        if (row.assigneeTier === 'L1') {
            return {
                title: 'Reassign for Final Reviewer?',
                message: 'Are you sure you want to reassign this contract to the Final Reviewer?',
            };
        }
        return {
            title: 'Assign to Final Review?',
            message: 'Are you sure you want to assign this contract to Final Review?',
        };
    }
    if (kind === 'returnToCM') {
        return {
            title: 'Return to CM?',
            message: 'Are you sure you want to return this contract to the Contract Manager?',
        };
    }
    if (kind === 'salesSupport') {
        return {
            title: 'Return to Sales Support?',
            message: 'Are you sure you want to return this contract to Sales Support?',
        };
    }
    return {
        title: 'Set to Fund?',
        message: 'Are you sure you want to set this contract to Fund? This is irreversible once submitted.',
    };
};
var FundingLog = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var filterOpen = _a.filterOpen, onCloseFilter = _a.onCloseFilter, queueType = _a.queueType, allQueueTypes = _a.allQueueTypes, onFilterStateChange = _a.onFilterStateChange, onQueueCountChange = _a.onQueueCountChange, onQueueAmountChange = _a.onQueueAmountChange, onInProgressCountryAmountsChange = _a.onInProgressCountryAmountsChange, onTotalCountChange = _a.onTotalCountChange, onAssignedToMyselfFromDrawer = _a.onAssignedToMyselfFromDrawer, onRefreshReady = _a.onRefreshReady, onExportReady = _a.onExportReady, onLastRefreshedChange = _a.onLastRefreshedChange, onFetchingChange = _a.onFetchingChange, onNewCountsChange = _a.onNewCountsChange, onDetailsPanelOpenChange = _a.onDetailsPanelOpenChange, detailsPanelContainer = _a.detailsPanelContainer;
    var navigate = useNavigate();
    var _m = useFundingLog(queueType, allQueueTypes), fundingLogRows = _m.fundingLogRows, newRowIds = _m.newRowIds, newCounts = _m.newCounts, isManualRefreshing = _m.isManualRefreshing, isRefreshingInBackground = _m.isRefreshingInBackground, isFetching = _m.isFetching, totalCount = _m.totalCount, queueCounts = _m.queueCounts, queueAmounts = _m.queueAmounts, inProgressCountryAmounts = _m.inProgressCountryAmounts, refreshCurrentQueue = _m.refreshCurrentQueue, fetchFundingLogRowsForExport = _m.fetchFundingLogRowsForExport, lastRefreshedAt = _m.lastRefreshedAt, accountAspireOId = _m.accountAspireOId, currentPage = _m.currentPage, setCurrentPage = _m.setCurrentPage, perPageCount = _m.perPageCount, setPerPageCount = _m.setPerPageCount, sortBy = _m.sortBy, sortOrder = _m.sortOrder, handleTableSortChange = _m.handleTableSortChange, appliedFilters = _m.appliedFilters, applyFilters = _m.applyFilters, resetFilters = _m.resetFilters, programsList = _m.programsList, statusList = _m.statusList, fundingMethodList = _m.fundingMethodList, financeProgramGroupList = _m.financeProgramGroupList, fetchFundingMethodList = _m.fetchFundingMethodList, salesRepList = _m.salesRepList, fetchComments = _m.fetchComments, sendComment = _m.sendComment, assignToMe = _m.assignToMe, moveToL2Manager = _m.moveToL2Manager, updateBacklogContractStatus = _m.updateBacklogContractStatus, reassignToOther = _m.reassignToOther, fetchContractManagers = _m.fetchContractManagers, fetchContractStatusHistory = _m.fetchContractStatusHistory;
    var dispatch = useDispatch();
    var currentUserFirstName = useSelector(function (store) { var _a; return (_a = store.User.userData) === null || _a === void 0 ? void 0 : _a.firstName; });
    var currentUserLastName = useSelector(function (store) { var _a; return (_a = store.User.userData) === null || _a === void 0 ? void 0 : _a.lastName; });
    var currentUserInitials = [currentUserFirstName, currentUserLastName]
        .filter(Boolean)
        .map(function (namePart) { return namePart.charAt(0).toUpperCase(); })
        .join('');
    var currentUserRoleDescription = useSelector(function (store) { var _a; return (_a = store.User.userData) === null || _a === void 0 ? void 0 : _a.RoleDescription; });
    var currentUserRoleTier = deriveFundingLogRoleTier(currentUserRoleDescription);
    var currentUserIsReviewer = isFundingLogReviewerRole(currentUserRoleDescription);
    var isSalesSupport = useSelector(function (store) { var _a; return (_a = store.User.userData) === null || _a === void 0 ? void 0 : _a.RoleType; }) === 'SALES_SUPPORT';
    var currentUserCanComment = currentUserIsReviewer || isSalesSupport;
    var _o = useState(null), selectedRowForComments = _o[0], setSelectedRowForComments = _o[1];
    var _p = useState([]), rowComments = _p[0], setRowComments = _p[1];
    var _q = useState(false), isLoadingComments = _q[0], setIsLoadingComments = _q[1];
    var _r = useState(false), isAssignErrorPopupOpen = _r[0], setIsAssignErrorPopupOpen = _r[1];
    var _s = useState(false), isStatusHistoryOpen = _s[0], setIsStatusHistoryOpen = _s[1];
    var _t = useState([]), statusHistoryRows = _t[0], setStatusHistoryRows = _t[1];
    var _u = useState(false), isLoadingStatusHistory = _u[0], setIsLoadingStatusHistory = _u[1];
    var _v = useState(null), pendingFundingAction = _v[0], setPendingFundingAction = _v[1];
    var _w = useState(null), reassignTargetRow = _w[0], setReassignTargetRow = _w[1];
    var _x = useState([]), cmMembers = _x[0], setCmMembers = _x[1];
    var _y = useState(false), isLoadingCmMembers = _y[0], setIsLoadingCmMembers = _y[1];
    var _z = useState(false), isReassignSubmitting = _z[0], setIsReassignSubmitting = _z[1];
    var hasFetchedCmMembersRef = useRef(false);
    useEffect(function () {
        if (filterOpen) {
            setSelectedRowForComments(null);
        }
    }, [filterOpen]);
    useEffect(function () {
        onDetailsPanelOpenChange === null || onDetailsPanelOpenChange === void 0 ? void 0 : onDetailsPanelOpenChange(Boolean(selectedRowForComments));
    }, [selectedRowForComments]);
    useEffect(function () {
        setCurrentPage(1);
    }, [queueType]);
    var handleRowClick = function (row) {
        navigate("".concat(navConfig.BacklogAppDetails, "/").concat(row.id), {
            state: { fundingLogRow: row, returnTo: { path: navConfig.FundingLogManagement, queueType: queueType } },
        });
    };
    var handleAssignToMe = function (row, options) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, assignToMe(row.id)];
                case 1:
                    result = _a.sent();
                    if (result.accountNotInAspire) {
                        setIsAssignErrorPopupOpen(true);
                        return [2];
                    }
                    if (result.success && (options === null || options === void 0 ? void 0 : options.landOnMyQueue)) {
                        onAssignedToMyselfFromDrawer === null || onAssignedToMyselfFromDrawer === void 0 ? void 0 : onAssignedToMyselfFromDrawer();
                        setSelectedRowForComments(null);
                    }
                    return [2];
            }
        });
    }); };
    var isFinalReviewWarning = Boolean(pendingFundingAction
        && pendingFundingAction.kind === 'l2'
        && currentUserIsReviewer
        && currentUserRoleTier === 'L1'
        && !pendingFundingAction.row.assigneeTier
        && !pendingFundingAction.row.assigneeName);
    var pendingFundingConfirmation = pendingFundingAction
        ? getFundingActionConfirmation(pendingFundingAction.kind, pendingFundingAction.row)
        : null;
    var handleAssignToL2 = function (row) {
        setPendingFundingAction({ kind: 'l2', row: row });
    };
    var handleAssignToSalesSupport = function (row) {
        setPendingFundingAction({ kind: 'salesSupport', row: row });
    };
    var handleOpenReassignPopup = function (row) {
        setReassignTargetRow(row);
        if (!hasFetchedCmMembersRef.current) {
            hasFetchedCmMembersRef.current = true;
            setIsLoadingCmMembers(true);
            fetchContractManagers()
                .then(setCmMembers)
                .finally(function () { return setIsLoadingCmMembers(false); });
        }
    };
    var handleReassignConfirm = function (memberId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!reassignTargetRow)
                        return [2];
                    setIsReassignSubmitting(true);
                    return [4, reassignToOther(reassignTargetRow.id, memberId)];
                case 1:
                    result = _a.sent();
                    setIsReassignSubmitting(false);
                    if (result.success) {
                        setReassignTargetRow(null);
                        setSelectedRowForComments(null);
                    }
                    return [2];
            }
        });
    }); };
    var handleCommentsClick = function (row) { return __awaiter(void 0, void 0, void 0, function () {
        var comments;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    onCloseFilter();
                    dispatch(app_actions.closeLeftMenu());
                    setSelectedRowForComments(row);
                    setRowComments([]);
                    setIsLoadingComments(true);
                    return [4, fetchComments(row.id)];
                case 1:
                    comments = _a.sent();
                    setIsLoadingComments(false);
                    setRowComments(comments);
                    return [2];
            }
        });
    }); };
    var handleAddComment = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var newComment, refreshedComments;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedRowForComments)
                        return [2, false];
                    return [4, sendComment(selectedRowForComments.id, payload)];
                case 1:
                    newComment = _a.sent();
                    if (!newComment)
                        return [2, false];
                    return [4, fetchComments(selectedRowForComments.id)];
                case 2:
                    refreshedComments = _a.sent();
                    setRowComments(refreshedComments);
                    return [2, true];
            }
        });
    }); };
    var handleApplyFilters = function (draft) {
        applyFilters(draft);
        onCloseFilter();
    };
    var hasActiveFilters = Boolean(appliedFilters.country
        || ((_c = (_b = appliedFilters.programs) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0
        || ((_e = (_d = appliedFilters.status) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0) > 0
        || ((_g = (_f = appliedFilters.fundingMethods) === null || _f === void 0 ? void 0 : _f.length) !== null && _g !== void 0 ? _g : 0) > 0
        || ((_j = (_h = appliedFilters.financeProgramGroups) === null || _h === void 0 ? void 0 : _h.length) !== null && _j !== void 0 ? _j : 0) > 0
        || ((_l = (_k = appliedFilters.salesRep) === null || _k === void 0 ? void 0 : _k.length) !== null && _l !== void 0 ? _l : 0) > 0
        || appliedFilters.passedToBookingDateStart
        || appliedFilters.expectedFundingDateStart
        || appliedFilters.fundingDateStart
        || appliedFilters.bookedDateStart);
    var activeFilterChips = useMemo(function () {
        var _a, _b, _c, _d, _e;
        var chips = [];
        if (appliedFilters.country) {
            chips.push({
                id: "country-".concat(appliedFilters.country.value),
                label: appliedFilters.country.label,
                onRemove: function () { return applyFilters(__assign(__assign({}, appliedFilters), { country: null })); },
            });
        }
        ((_a = appliedFilters.programs) !== null && _a !== void 0 ? _a : []).forEach(function (program) {
            chips.push({
                id: "program-".concat(program.value),
                label: program.label,
                onRemove: function () { return applyFilters(__assign(__assign({}, appliedFilters), { programs: appliedFilters.programs.filter(function (item) { return item !== program; }) })); },
            });
        });
        ((_b = appliedFilters.status) !== null && _b !== void 0 ? _b : []).forEach(function (status) {
            chips.push({
                id: "status-".concat(status.value),
                label: status.label,
                onRemove: function () { return applyFilters(__assign(__assign({}, appliedFilters), { status: appliedFilters.status.filter(function (item) { return item !== status; }) })); },
            });
        });
        ((_c = appliedFilters.fundingMethods) !== null && _c !== void 0 ? _c : []).forEach(function (method) {
            chips.push({
                id: "fundingMethod-".concat(method.value),
                label: method.label,
                onRemove: function () { return applyFilters(__assign(__assign({}, appliedFilters), { fundingMethods: appliedFilters.fundingMethods.filter(function (item) { return item !== method; }) })); },
            });
        });
        ((_d = appliedFilters.financeProgramGroups) !== null && _d !== void 0 ? _d : []).forEach(function (group) {
            chips.push({
                id: "financeProgramGroup-".concat(group.value),
                label: group.label,
                onRemove: function () { return applyFilters(__assign(__assign({}, appliedFilters), { financeProgramGroups: appliedFilters.financeProgramGroups.filter(function (item) { return item !== group; }) })); },
            });
        });
        ((_e = appliedFilters.salesRep) !== null && _e !== void 0 ? _e : []).forEach(function (rep) {
            chips.push({
                id: "salesRep-".concat(rep.value),
                label: rep.label,
                onRemove: function () { return applyFilters(__assign(__assign({}, appliedFilters), { salesRep: appliedFilters.salesRep.filter(function (item) { return item !== rep; }) })); },
            });
        });
        if (appliedFilters.passedToBookingDateStart) {
            chips.push({
                id: 'passedToBookingDate',
                label: buildDateRangeChipLabel(DATE_RANGE_FILTER_LABELS.passedToBookingDate, appliedFilters.passedToBookingDateStart, appliedFilters.passedToBookingDateEnd),
                onRemove: function () { return applyFilters(__assign(__assign({}, appliedFilters), { passedToBookingDateStart: '', passedToBookingDateEnd: '' })); },
            });
        }
        if (appliedFilters.expectedFundingDateStart) {
            chips.push({
                id: 'expectedFundingDate',
                label: buildDateRangeChipLabel(DATE_RANGE_FILTER_LABELS.expectedFundingDate, appliedFilters.expectedFundingDateStart, appliedFilters.expectedFundingDateEnd),
                onRemove: function () { return applyFilters(__assign(__assign({}, appliedFilters), { expectedFundingDateStart: '', expectedFundingDateEnd: '' })); },
            });
        }
        if (appliedFilters.fundingDateStart) {
            chips.push({
                id: 'fundingDate',
                label: buildDateRangeChipLabel(DATE_RANGE_FILTER_LABELS.fundingDate, appliedFilters.fundingDateStart, appliedFilters.fundingDateEnd),
                onRemove: function () { return applyFilters(__assign(__assign({}, appliedFilters), { fundingDateStart: '', fundingDateEnd: '' })); },
            });
        }
        if (appliedFilters.bookedDateStart) {
            chips.push({
                id: 'bookedDate',
                label: buildDateRangeChipLabel(DATE_RANGE_FILTER_LABELS.bookedDate, appliedFilters.bookedDateStart, appliedFilters.bookedDateEnd),
                onRemove: function () { return applyFilters(__assign(__assign({}, appliedFilters), { bookedDateStart: '', bookedDateEnd: '' })); },
            });
        }
        return chips;
    }, [appliedFilters, applyFilters]);
    useEffect(function () {
        onFilterStateChange === null || onFilterStateChange === void 0 ? void 0 : onFilterStateChange({ hasActiveFilters: hasActiveFilters, chips: activeFilterChips, country: appliedFilters.country });
    }, [hasActiveFilters, activeFilterChips]);
    useEffect(function () {
        onQueueCountChange === null || onQueueCountChange === void 0 ? void 0 : onQueueCountChange(queueCounts);
    }, [queueCounts]);
    useEffect(function () {
        onQueueAmountChange === null || onQueueAmountChange === void 0 ? void 0 : onQueueAmountChange(queueAmounts);
    }, [queueAmounts]);
    useEffect(function () {
        onInProgressCountryAmountsChange === null || onInProgressCountryAmountsChange === void 0 ? void 0 : onInProgressCountryAmountsChange(inProgressCountryAmounts);
    }, [inProgressCountryAmounts]);
    useEffect(function () {
        if (filterOpen)
            fetchFundingMethodList();
    }, [filterOpen]);
    useEffect(function () {
        onTotalCountChange === null || onTotalCountChange === void 0 ? void 0 : onTotalCountChange(totalCount);
    }, [totalCount]);
    useEffect(function () {
        onLastRefreshedChange === null || onLastRefreshedChange === void 0 ? void 0 : onLastRefreshedChange(lastRefreshedAt);
    }, [lastRefreshedAt]);
    useEffect(function () {
        onFetchingChange === null || onFetchingChange === void 0 ? void 0 : onFetchingChange(isFetching || isManualRefreshing);
    }, [isFetching, isManualRefreshing]);
    useEffect(function () {
        onNewCountsChange === null || onNewCountsChange === void 0 ? void 0 : onNewCountsChange(newCounts);
    }, [newCounts]);
    useEffect(function () {
        onRefreshReady === null || onRefreshReady === void 0 ? void 0 : onRefreshReady(refreshCurrentQueue);
    }, [refreshCurrentQueue]);
    var handleStatusHistoryClick = function (row) { return __awaiter(void 0, void 0, void 0, function () {
        var history;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsStatusHistoryOpen(true);
                    setStatusHistoryRows([]);
                    setIsLoadingStatusHistory(true);
                    return [4, fetchContractStatusHistory(row.id)];
                case 1:
                    history = _a.sent();
                    setIsLoadingStatusHistory(false);
                    setStatusHistoryRows(history);
                    return [2];
            }
        });
    }); };
    var handleConfirmFundingAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var action, success_1, contractStatus, success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    action = pendingFundingAction;
                    setPendingFundingAction(null);
                    if (!action)
                        return [2];
                    if (!(action.kind === 'l2')) return [3, 2];
                    return [4, moveToL2Manager(action.row.id)];
                case 1:
                    success_1 = _a.sent();
                    if (success_1) {
                        setSelectedRowForComments(null);
                    }
                    return [2];
                case 2:
                    contractStatus = action.kind === 'funded'
                        ? FUNDING_LOG_CONTRACT_STATUS.FUNDED
                        : action.kind === 'returnToCM'
                            ? FUNDING_LOG_CONTRACT_STATUS.RETURNED_TO_CM
                            : FUNDING_LOG_CONTRACT_STATUS.SALES_SUPPORT;
                    return [4, updateBacklogContractStatus(action.row, contractStatus)];
                case 3:
                    success = _a.sent();
                    if (success) {
                        setSelectedRowForComments(null);
                    }
                    return [2];
            }
        });
    }); };
    var visibleColumnKeys = useMemo(function () {
        var optionalColumnKeys = ALL_FUNDING_LOG_COLUMNS
            .map(function (column) { return column.key; })
            .filter(function (key) { return !FUNDING_LOG_FIXED_COLUMN_KEYS.includes(key); });
        var keys = __spreadArray(__spreadArray([], optionalColumnKeys, true), ['action'], false);
        return queueType === 'ALL' ? keys : keys.filter(function (key) { return key !== 'bookedDate' && key !== 'fundingStatus'; });
    }, [queueType]);
    useEffect(function () {
        onExportReady === null || onExportReady === void 0 ? void 0 : onExportReady(function (format, viewLabel) { return exportFundingLog({
            fetchRows: fetchFundingLogRowsForExport,
            format: format,
            viewLabel: viewLabel,
            visibleColumnKeys: visibleColumnKeys,
        }); });
    }, [fetchFundingLogRowsForExport, visibleColumnKeys]);
    return (React.createElement(React.Fragment, null,
        React.createElement(BacklogViewWrapper, { sx: { flex: 1, minHeight: 0 } },
            React.createElement(Box, { className: "backlogMainContent" },
                React.createElement(FundingLogTable, { rows: fundingLogRows, newRowIds: newRowIds, isFetching: isFetching, isRefreshing: isRefreshingInBackground, emptyStateSubtitle: queueType === 'MY_QUEUE'
                        ? "Nothing is currently assigned to you. Contracts you pick up will appear here."
                        : 'Nothing currently requires action here. New deals will appear automatically as Aspire passes them to booking.', onRowClick: handleRowClick, onAssignToMe: handleAssignToMe, onAssignToL2: handleAssignToL2, onAssignToSalesSupport: handleAssignToSalesSupport, onReassignToOther: handleOpenReassignPopup, currentUserAccountAspireOId: accountAspireOId, currentUserInitials: currentUserInitials, currentUserRoleTier: currentUserRoleTier, currentUserIsReviewer: currentUserIsReviewer, canComment: currentUserCanComment, onCommentsClick: handleCommentsClick, selectedRowId: selectedRowForComments === null || selectedRowForComments === void 0 ? void 0 : selectedRowForComments.id, onStatusHistoryClick: handleStatusHistoryClick, sortBy: sortBy, sortOrder: sortOrder, onSortChange: handleTableSortChange, visibleColumnKeys: visibleColumnKeys })),
            filterOpen && (React.createElement(Box, { className: "backlogFilters" },
                React.createElement(FundingLogFilter, { initialDraft: appliedFilters, programOptions: programsList, statusOptions: statusList, fundingMethodOptions: fundingMethodList, financeProgramGroupOptions: financeProgramGroupList, salesRepOptions: salesRepList, onApply: handleApplyFilters, onCancel: onCloseFilter, onReset: resetFilters })))),
        selectedRowForComments && detailsPanelContainer && createPortal(React.createElement(FundingLogCommentsPanel, { row: selectedRowForComments, comments: rowComments, isLoadingComments: isLoadingComments, onClose: function () { return setSelectedRowForComments(null); }, onAddComment: handleAddComment, canManage: currentUserIsReviewer && deriveFundingLogCanManage(selectedRowForComments, accountAspireOId, currentUserRoleTier), currentUserRoleTier: currentUserRoleTier, canComment: currentUserCanComment, onReturnToCM: isSalesSupport ? function () { return selectedRowForComments && setPendingFundingAction({ kind: 'returnToCM', row: selectedRowForComments }); } : undefined, onAssignToMyself: function () { return selectedRowForComments && handleAssignToMe(selectedRowForComments, { landOnMyQueue: true }); }, onMoveToL2Manager: function () { return selectedRowForComments && setPendingFundingAction({ kind: 'l2', row: selectedRowForComments }); }, onMoveToSalesSupport: function () { return selectedRowForComments && setPendingFundingAction({ kind: 'salesSupport', row: selectedRowForComments }); }, onSetToFunded: function () { return selectedRowForComments && setPendingFundingAction({ kind: 'funded', row: selectedRowForComments }); }, onReassignToOther: function () { return selectedRowForComments && handleOpenReassignPopup(selectedRowForComments); }, onStatusHistoryClick: function () { return handleStatusHistoryClick(selectedRowForComments); }, onViewDetailsClick: function () { return selectedRowForComments && handleRowClick(selectedRowForComments); } }), detailsPanelContainer),
        React.createElement(BacklogPagination, { currentPage: currentPage, perPageCount: perPageCount, totalCount: totalCount !== null && totalCount !== void 0 ? totalCount : 0, onPageChange: setCurrentPage, onPerPageChange: function (count) {
                setPerPageCount(count);
                setCurrentPage(1);
            }, className: "backlog-list-pagination", defaultPerPageCount: 100 }),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.EVENT_NOT_ALLOWED, titleText: "Unable to Assign", message: FUNDING_LOG_ACCOUNT_NOT_IN_ASPIRE_MESSAGE, acceptBtnText: "OK", open: isAssignErrorPopupOpen, acceptCallBack: function () { return setIsAssignErrorPopupOpen(false); } }),
        React.createElement(FundingLogStatusHistoryPopup, { open: isStatusHistoryOpen, onClose: function () { return setIsStatusHistoryOpen(false); }, rows: statusHistoryRows, isLoading: isLoadingStatusHistory }),
        pendingFundingAction && isFinalReviewWarning && (React.createElement(FundingLogFinalReviewWarningPopup, { open: true, subtitle: [pendingFundingAction.row.contractId, pendingFundingAction.row.customerName].filter(function (part) { return part && part !== '--'; }).join(' · '), onContinue: handleConfirmFundingAction, onCancel: function () { return setPendingFundingAction(null); } })),
        pendingFundingAction && pendingFundingConfirmation && !isFinalReviewWarning && (React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, titleText: pendingFundingConfirmation.title, message: pendingFundingConfirmation.message, acceptBtnText: "Yes", denyBtnText: "No", open: Boolean(pendingFundingAction), acceptCallBack: handleConfirmFundingAction, denyCallBack: function () { return setPendingFundingAction(null); }, cancelCallBack: function () { return setPendingFundingAction(null); } })),
        reassignTargetRow && (React.createElement(FundingLogReassignPopup, { open: Boolean(reassignTargetRow), onClose: function () { return setReassignTargetRow(null); }, contractId: reassignTargetRow.contractId, customerName: reassignTargetRow.customerName, members: cmMembers, currentAssignees: getFundingLogRowCurrentAssignees(reassignTargetRow), restrictToFinalReviewers: getFundingLogRowHasFinalReviewCM(reassignTargetRow), isLoadingMembers: isLoadingCmMembers, isSubmitting: isReassignSubmitting, onReassign: handleReassignConfirm }))));
};
export default FundingLog;
